import React, { useState } from "react";

import styled from "styled-components";

import Alert from "components/atoms/alert/Alert";
import Checkbox from "components/atoms/input/Checkbox";
import FormInput from "components/atoms/input/FormInput";
import Text from "components/atoms/text/Text";

import AbstractModal from "components/page/modal/AbstractModal";

const Container = styled.div`
    width: 100%;
`;

const Row = styled.div`
    display: flex;
    align-items: center;
    margin: ${(props) => props.$margin || "0 0 0 0"};
`;

const ContentsText = styled(Text)`
    font-size: 1.4rem;
    margin-bottom: 24px;
`;

const AgreeText = styled(Text)`
    font-size: 1.4rem;
    margin-left: 8px;
    color: var(--color-SubBlack);
`;

const LinkText = styled.span`
    color: var(--color-SubBlack);
    cursor: pointer;
    text-decoration: underline;
`;

function UserRegisterModal(props) {
    const [agreeTerms, setAgreeTerms] = useState({
        terms: false,
        marketing: false,
    });
    const [name, setName] = useState(props.user ? props.user.split("@")[0] : "");

    return (
        <AbstractModal
            modalTitle="회원가입"
            width={400}
            height={640}
            exitModal={props.exitModal}
            footer={{
                leftBtnText: "취소",
                rightBtnText: "회원가입",
                leftOnClick: props.exitModal,
                rightOnClick: () => {
                    if (!agreeTerms.terms) {
                        Alert("warn", "동의", "필수 항목에 동의해주세요.");
                        return;
                    }
                    if (name.trim() === "") {
                        Alert("warn", "프로필 이름", "프로필 이름을 입력해주세요.");
                        return;
                    }

                    props.register({
                        is_marketing_agreed: agreeTerms.marketing,
                        name: name,
                    });
                },
                disabled: false,
            }}
        >
            <Container>
                <ContentsText>미가입된 아이디입니다. 회원가입하겠습니까?</ContentsText>

                <Row>
                    <FormInput
                        label="이메일"
                        margin="0 0 16px 0"
                        width="100%"
                        value={props.user}
                        readOnly={true}
                        disabled={true}
                    />
                </Row>
                <Row>
                    <FormInput
                        label="프로필 이름"
                        width="100%"
                        placeholder="프로필 이름을 입력해주세요."
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        textAlign="left"
                    />
                </Row>
                <Row $margin={"24px 0 0 0"}>
                    <Checkbox
                        margin={"0"}
                        checked={agreeTerms.terms}
                        onChange={(e) => setAgreeTerms({ ...agreeTerms, terms: !agreeTerms.terms })}
                    />
                    <AgreeText>
                        (필수){" "}
                        <LinkText onClick={() => window.open("/terms-of-service", "_blank", "noopener noreferrer")}>
                            이용 약관
                        </LinkText>{" "}
                        및{" "}
                        <LinkText onClick={() => window.open("/privacy-policy", "_blank", "noopener noreferrer")}>
                            개인정보 수집 및 이용
                        </LinkText>{" "}
                        동의
                    </AgreeText>
                </Row>
                <Row $margin={"8px 0 0 0"}>
                    <Checkbox
                        margin={"0"}
                        checked={agreeTerms.marketing}
                        onChange={(e) => setAgreeTerms({ ...agreeTerms, marketing: !agreeTerms.marketing })}
                    />
                    <AgreeText>(선택) 마케팅 정보 수신 동의</AgreeText>
                </Row>
            </Container>
        </AbstractModal>
    );
}

export default UserRegisterModal;
